import { Box } from '@mui/material'
import React from 'react'
import WTypography from '../whiteTypography'
import styled from '@emotion/styled'
const useStyles = styled({
  root: {
    background: '#001B42',
    padding: '30px 20px 20px 40px',
    borderRadius: '7px',
    marginBottom: '5px',
    display: 'flex',
    width: ({ width }) => width,
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  text: {
    margin: '10px !important',
  },
})
function EvolutionCard({ data, text, width }) {
  const classes = useStyles({ width: width })

  return (
    <Box className={classes.root}>
      <WTypography align="right" variant="h4">
        {data}%
      </WTypography>
      <WTypography className={classes.text} align="right">
        {text}
      </WTypography>
    </Box>
  )
}

export default EvolutionCard
